/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FetchAddressAutocompleteResultsRequest} from '@cash-web/protos/squareup/cash/cashaddressenrichment/app/v1/address_autocomplete_messages.pb'
import {FetchAddressAutocompleteResultsResponse} from '@cash-web/protos/squareup/cash/cashaddressenrichment/app/v1/address_autocomplete_messages.pb'


export const fetchAddressAutocompleteResults = (request: FetchAddressAutocompleteResultsRequest, options?: CashRequestOptions) => post<FetchAddressAutocompleteResultsRequest, FetchAddressAutocompleteResultsResponse>("/cash-app/address-autocomplete/v1/fetch-address-autocomplete-results", request, {...options, rejectOnError: true })